"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FeedbackCopy;
(function (FeedbackCopy) {
    FeedbackCopy["InitialPrompt1"] = "How's Buoy working for you?";
    FeedbackCopy["InitialPrompt2"] = "We'd love your thoughts on the experience.";
    FeedbackCopy["GiveFeedback"] = "Give Feedback \u2192";
    FeedbackCopy["Satisfaction"] = "How would you rate your satisfaction with your experience on Buoy?";
    FeedbackCopy["Dissatisfied"] = "Extremely dissatisfied";
    FeedbackCopy["Satisfied"] = "Extremely satisfied";
    FeedbackCopy["NPS"] = "How likely or unlikely are you to recommend Buoy to a friend or colleague?";
    FeedbackCopy["VeryLikely"] = "Very likely";
    FeedbackCopy["NotLikely"] = "Not likely";
    FeedbackCopy["FreeText"] = "How can we improve? Please share any additional thoughts about your experience with Buoy (the more, the better).";
    FeedbackCopy["FreeTextPlaceholder"] = "Comments or suggestions?";
    FeedbackCopy["ThankYou"] = "Thank you for your feedback!";
    FeedbackCopy["ThankYouParagraph1"] = "Buoy values your feedback. The more we know about what\u2019s working \u2013 and what could improve \u2013 the better we can make our experience.";
    FeedbackCopy["ThankYouParagraph2"] = "If you\u2019re up for it, there\u2019s another opportunity to share feedback by way of a quick 2 minute survey.";
    FeedbackCopy["TakeOurSurvey"] = "Take our survey!";
    FeedbackCopy["Close"] = "Close";
    FeedbackCopy["Submit"] = "Submit";
    FeedbackCopy["Next"] = "Next";
    FeedbackCopy["Optional"] = "Optional";
    FeedbackCopy["Legal"] = "Your feedback is very important to us and will be used to improve our services. Please do not include any sensitive information with your feedback (such as your birth date or medical history). We protect your personal information in accordance with our";
    FeedbackCopy["Privacy"] = "Privacy Notice";
    FeedbackCopy["SorryAboutThat"] = "Sorry about that. How can we improve?";
    FeedbackCopy["HelpUsImprove"] = "Help us improve by sharing why.";
    FeedbackCopy["AnythingElse"] = "Anything else to share? (optional)";
    FeedbackCopy["SelectAll"] = "Select all that apply";
    FeedbackCopy["Great"] = "Great! Could you share any additional thoughts about your experience with Buoy?";
    FeedbackCopy["FollowUp"] = "Stay up to date with medical news and treatment offers.";
})(FeedbackCopy || (FeedbackCopy = {}));
exports.default = FeedbackCopy;
//# sourceMappingURL=FeedbackCopy.js.map